import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "queryScriptLanguage",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Card = _resolveComponent("Card")
  const _component_HelpDialog = _resolveComponent("HelpDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              id: "dataSource",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.dataset.dataSource.$invalid && _ctx.v$.dataset.dataSource.$dirty
                        }],
              style: _ctx.queryDescriptor.style.maxWidth,
              options: _ctx.dataSources,
              optionLabel: "label",
              optionValue: "label",
              modelValue: _ctx.v$.dataset.dataSource.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.dataSource.$model = $event)),
              onBeforeShow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.dataSource.$touch()))
            }, null, 8, ["style", "options", "modelValue", "class"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.businessModelManager.dataSource')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.dataset.dataSource,
            additionalTranslateParams: {
                        fieldName: _ctx.$t('managers.businessModelManager.dataSource')
                    }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary " }, {
          start: _withCtx(() => [
            (!_ctx.expandQueryCard)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "fas fa-chevron-right",
                  class: "p-button-text p-button-rounded p-button-plain",
                  style: {"color":"white"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expandQueryCard = true))
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  icon: "fas fa-chevron-down",
                  class: "p-button-text p-button-rounded p-button-plain",
                  style: {"color":"white"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expandQueryCard = false))
                })),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.datasetManagement.editQuery')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "fas fa-info-circle",
              class: "p-button-text p-button-rounded p-button-plain p-col-1",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.helpDialogVisible = true))
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode(_component_VCodeMirror, {
              ref: "codeMirror",
              value: _ctx.dataset.query,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataset.query = $event)),
              autoHeight: true,
              options: _ctx.codemirrorOptions,
              onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('queryEdited')))
            }, null, 8, ["value", "options"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.expandQueryCard]
        ]),
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-2" }, {
          start: _withCtx(() => [
            (!_ctx.expandScriptCard)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "fas fa-chevron-right",
                  class: "p-button-text p-button-rounded p-button-plain",
                  style: {"color":"white"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.expandScriptCard = true))
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  icon: "fas fa-chevron-down",
                  class: "p-button-text p-button-rounded p-button-plain",
                  style: {"color":"white"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.expandScriptCard = false))
                })),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.datasetManagement.editScript')), 1)
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_Card, null, {
          content: _withCtx(() => [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_Dropdown, {
                id: "queryScriptLanguage",
                class: "kn-material-input",
                style: _ctx.queryDescriptor.style.maxWidth,
                options: _ctx.scriptTypes,
                optionLabel: "VALUE_NM",
                optionValue: "VALUE_CD",
                modelValue: _ctx.dataset.queryScriptLanguage,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dataset.queryScriptLanguage = $event)),
                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onLanguageChanged($event.value)))
              }, null, 8, ["style", "options", "modelValue"]),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.lovsManagement.placeholderScript')), 1)
            ]),
            _createVNode(_component_VCodeMirror, {
              class: "p-mt-2",
              ref: "codeMirrorScript",
              value: _ctx.dataset.queryScript,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataset.queryScript = $event)),
              autoHeight: true,
              options: _ctx.scriptOptions,
              onKeyup: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["value", "options"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.expandScriptCard]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_HelpDialog, {
      visible: _ctx.helpDialogVisible,
      onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.helpDialogVisible = false))
    }, null, 8, ["visible"])
  ], 64))
}